<template>
  <div id="graduate" class="home">
    <el-container>
      <div class="content-wrap"  style="min-height:81vh;">
        <div class="condition">    
          <el-row type="flex" align="middle" class="condition-row">                
            <el-col :span="24">
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">地区：{{city}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">行业：{{industry}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">企业性质：{{property}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">规模：{{size}}</el-tag></div>              
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">部门：{{dep}}</el-tag></div>              
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">学历：{{level}}</el-tag></div>                                
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">外语：{{grade}}</el-tag></div>              
            </el-col>
          </el-row>    
          <el-row :gutter="40">
            <el-col :span="12" style="background-color:#ffffff;">
              <div v-loading="loading" :style="{height:'430px',width:'100%'}" ref="myEchart1"></div>
            </el-col>            
            <el-col :span="12" style="background-color:#ffffff">              
              <el-row type="flex" align="middle" class="condition-row">                
                <el-col :span="24">
                  <el-divider content-position="left">地区:</el-divider>
                  <div class="condition-checked" v-for="(item,index) in citys" :key="index">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="selectCity(indus.name)"  v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>                    
                      </el-dropdown-menu>           
                    </el-dropdown>
                  </div>
                </el-col>
              </el-row>              
              <el-row type="flex" align="middle" :gutter="20" class="condition-row">                
                <el-col :span="12">
                  <div class="condition-checked" style="width:100%">
                    <el-select v-model="industry" style="width:100%" placeholder="请选择行业" >
                      <el-option
                        v-for="item in industryOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>               
                </el-col>
                <el-col :span="12">
                  <div class="condition-checked"  style="width:100%">
                    <el-select v-model="property" style="width:100%" placeholder="请选择企业性质">
                      <el-option
                        v-for="item in propertyOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>                  
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" :gutter="20" class="condition-row">                
                <el-col :span="12">
                  <div class="condition-checked" style="width:100%">
                    <el-select v-model="size" style="width:100%" placeholder="请选择规模">
                      <el-option
                        v-for="item in sizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="12">                                    
                  <div class="condition-checked" style="width:100%">
                    <el-select v-model="dep" style="width:100%" placeholder="请选择部门">
                      <el-option
                        v-for="item in depOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" :gutter="20" class="condition-row">                
                <el-col :span="12">                  
                  <div class="condition-checked" style="width:100%">
                    <el-select v-model="level" style="width:100%" placeholder="请选择学历">
                      <el-option
                        v-for="item in levelOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="condition-checked" style="width:100%">
                    <el-select v-model="grade" style="width:100%" placeholder="请选择外语水平">
                      <el-option
                        v-for="item in gradeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>                
              </el-row>
              <el-row style="margin-top:20px;">
                <el-col :span="24">
                  <el-button type="primary" :loading="loading" style="width:100%;margin-left:5px;" @click="submit">确定</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import helpers from '../helper';
import citys from '../utils/citys.js';
import echarts from 'echarts';
import customed from '../utils/customed';
import { fetchPost,fetchGet } from '../utils/http';
export default {
  name:'graduate',
  data(){
    return {
      loading:false,    
      citys:citys,
      city:'',
      industry:'',
      property:'',
      dep:'',
      level:'',
      size:'',
      grade:'',
      options:{},
      chart1:{},
      industryOptions:[{
        value: '金融/银行/保险/证券',
        label: '金融/银行/保险/证券'
      },
      {
        value: '计算机硬件及网络设备+IT服务/多领域经营+计算机软件+互联网/电子商务',
        label: '计算机硬件及网络设备+IT服务/多领域经营+计算机软件+互联网/电子商务'
      },
      {
        value: '航天和航空',
        label: '航天和航空'
      },
      {
        value: '通讯(设备/运营/增值服务)',
        label: '通讯(设备/运营/增值服务)'
      },
      {
        value: '电子技术/半导体',
        label: '电子技术/半导体'
      },
      {
        value: '环保',
        label: '环保'
      },
      {
        value: '房地产/建筑/装潢',
        label: '房地产/建筑/装潢'
      },
      {
        value: '仪器仪表及工业自动化',
        label: '仪器仪表及工业自动化'
      },
      {
        value: '教育/培训',
        label: '教育/培训'
      },
      {
        value: '能源/矿产',
        label: '能源/矿产'
      },
      {
        value: '广告/公关',
        label: '广告/公关'
      },
      {
        value: '政府/公共事业',
        label: '政府/公共事业'
      },
      {
        value: '咨询/管理产业/法律/财会',
        label: '咨询/管理产业/法律/财会'
      },
      {
        value: '贸易/进出口',
        label: '贸易/进出口'
      },
      {
        value: '医药/保健/生物工程',
        label: '医药/保健/生物工程'
      },
      {
        value: '汽车',
        label: '汽车'
      },
      {
        value: '学术/科研',
        label: '学术/科研'
      },
      {
        value: '快速消费品(食品/饮料/烟草/化妆品)',
        label: '快速消费品(食品/饮料/烟草/化妆品)'
      },
      {
        value: '耐用消费品(服装服饰/纺织/家具/家电)',
        label: '耐用消费品(服装服饰/纺织/家具/家电)'
      },
      {
        value: '大型设备/机电设备/重工业',
        label: '大型设备/机电设备/重工业'
      },
      {
        value: '化工/石化',
        label: '化工/石化'
      },
      {
        value: '传媒/出版/印刷/包装',
        label: '传媒/出版/印刷/包装'
      },
      {
        value: '旅游/酒店/餐饮',
        label: '旅游/酒店/餐饮'
      },
      {
        value: '娱乐/体育/休闲',
        label: '娱乐/体育/休闲'
      },
      {
        value: '交通/运输/物流',
        label: '交通/运输/物流'
      },
      {
        value: '加工制造',
        label: '加工制造'
      },
      {
        value: '零售/批发',
        label: '零售/批发'
      },
      {
        value: '农/林/牧/渔',
        label: '农/林/牧/渔'
      }],
      
      propertyOptions:[{
        value:'民营',
        label:'民营'
      },
      {
        value:'国有',
        label:'国有'
      },
      {
        value:'合资',
        label:'合资'
      },
      {
        value:'独资',
        label:'独资'
      },
      {
        value:'全部',
        label:'全部'
      }],
      sizeOptions:[{
        value:'50人以下',
        label:'50人以下'
      },{
        value:'50-100人',
        label:'50-100人'
      },{
        value:'201-500人',
        label:'201-500人'
      },{
        value:'501-1000人',
        label:'501-1000人'
      },{
        value:'1000人以上',
        label:'1000人以上'
      }],
      depOptions:[{
        value:'规划部门',
        label:'规划部门'
      },
      {
        value:'法律部门',
        label:'法律部门'
      },
      {
        value:'研发部门',
        label:'研发部门'
      },
      {
        value:'设计部门',
        label:'设计部门'
      },
      {
        value:'项目部门',
        label:'项目部门'
      },
      {
        value:'信息技术部门',
        label:'信息技术部门'
      },
      {
        value:'产品部门',
        label:'产品部门'
      },
      {
        value:'综合管理部门',
        label:'综合管理部门'
      },
      {
        value:'市场部门',
        label:'市场部门'
      },
      {
        value:'财务部门',
        label:'财务部门'
      },
      {
        value:'人事部门',
        label:'人事部门'
      },
      {
        value:'质量部门',
        label:'质量部门'
      },
      {
        value:'生产部门',
        label:'生产部门'
      },
      {
        value:'销售部门',
        label:'销售部门'
      },
      {
        value:'物流部门',
        label:'物流部门'
      },
      {
        value:'行政部门',
        label:'行政部门'
      },
      {
        value:'客服部门',
        label:'客服部门'
      },
      {
        value:'其他部门',
        label:'其他部门'
      }],
      levelOptions:[{
        value:'博士',
        label:'博士'
      },{
        value:'硕士',
        label:'硕士'
      },{
        value:'本科',
        label:'本科'
      },{
        value:'专科',
        label:'专科'
      },{
        value:'高中及以下',
        label:'高中及以下'
      }],
      gradeOptions:[{
        value:'精通',
        label:'精通'
      },{
        value:'一般',
        label:'一般'
      },{
        value:'较差',
        label:'较差'
      }]
    }
  },
  methods:{
    selectCity(value){
      this.city = value;
    },
    submit(){
      let city = this.city
      let industry = this.industry
      let property = this.property
      let size = this.size
      let dep = this.dep
      let level = this.level
      let grade = this.grade
      if( city == "" || industry == "" || property == "" || size == "" || dep == "" || level == "" || grade == ""){
        this.$notify({
          title:'提示',
          message:'请选择完整条件',
          type:'warning'
        })
        return
      }
      let token = sessionStorage.getItem('token');
      //未登录
      if(token == null){
        //未登录检查counter是否查询过
        if(localStorage.getItem('counter') == null){
          let _this = this
          _this.loading = true
          this.$http.post(
            helpers.BASE_URL + '/api/home/index/graduateSalary',
            {
              industry:industry,
              city:city,
              property:property,
              size:size,
              dep:dep,
              level:level,              
              grade:grade
            }
          )
          .then(function(res){
            localStorage.setItem('counter',1);
            setTimeout(()=>{
              _this.loading = false
            },2000)  
            if(res.data.code === 1){
              let data = res.data.data.graduate
              let newData = []
              data.map((value)=>{
                newData.push(parseInt(value))
              })            
              _this.options.series[0].data = newData;
              _this.chart1.setOption(_this.options,true)
            }else{
              _this.$notify({
                title:'错误',
                message:'发生错误,请重试',
                type:'error'
              })
            }            
          });
        }else{
          //未登录且免费次数已用完
          this.$notify({
            title:'提示',
            message:'游客只能使用一次，请登录后继续使用！',
            type:'warning'
          });
          this.$router.push('/login');
        }
      }
      //如果已登录
      if(token != null){
        let _this = this
        _this.loading = true
        this.$http.post(
          helpers.BASE_URL + '/api/home/index/graduateSalary',
          {
            industry:industry,
            city:city,
            property:property,
            size:size,
            dep:dep,
            level:level,              
            grade:grade
          }
        )
        .then(function(res){
          localStorage.setItem('counter',1);         
          if(res.data.code === 1){
            setTimeout(()=>{
              _this.loading = false
            },2000)
            let data = res.data.data.graduate
            let newData = []
            data.map((value)=>{
              newData.push(parseInt(value))
            })            
            _this.options.series[0].data = newData;
            _this.chart1.setOption(_this.options);    
          }else{
            _this.$notify({
              title:'错误',
              message:'发生错误,请重试',
              type:'error'
            })
          }
        })     
      }
    },
    init(){
      echarts.registerTheme('customed', customed)
      this.chart1 = echarts.init(this.$refs.myEchart1,"customed");
      this.options = {
        title:{
          text:'月总收入'
        },
        xAxis: {
          type: 'category',
          boundaryGap : true,
          data: ['10%分位', '25%分位', '50%分位', '75%分位', '90%分位']
        },      
        yAxis : [
          {
            type : 'value',
            axisLabel : {
              formatter: '￥{value} 元'
            }
          }
        ],
        legend: {
          data:['月总收入']
        },
        tooltip : {
          trigger: 'axis'
        },
        animationEasing: 'elasticOut',
        series: [{
          data: [0, 0, 0, 0, 0],
          type: 'line',
          lineStyle:{
            width:3
          },
          smooth: true
        }]
      };
      this.chart1.setOption(this.options);
    }
  },
  mounted(){
    setTimeout(()=>{
      this.init();
    },1000)
  }
}
</script>
<style scoped>
.home {
  background-color: #f4f4f4;
}
.content-wrap{
  width: 100%;
  margin-top: 60px; 
}
.condition{
  background-color: #ffffff;
  margin: 20px 100px;
  padding: 20px 40px;
  border-radius: 10px;
}
.condition-checked{
  margin: 5px 6px 0 0;
  padding: 10px 5px ;
  float: left;
  word-wrap:break-word;
}
.condition-row{
  margin-bottom: 4px;
}
.condition-row:nth-child(1){
  margin-bottom: 20px;
}
.condition-head{
  font-size: 14px;
  margin-right: 40px;
  display: inline-block;
  width: 80px;
  text-align: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #939393;
}
.el-dropdown-link:hover{
  color: #0bc8f4!important;
}
.el-dropdown-menu__item{
  line-height: 24px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-divider--horizontal {
  margin: 18px 0;
}
</style>
